import { Route, Routes } from 'react-router-dom';
import { Statistics as StatisticsView } from './components';

export const Statistics = () => {
  return (
    <Routes>
      <Route path="/" element={<StatisticsView />} />
    </Routes>
  );
};
